import { Stack } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import {
  METRICS_EARLIEST_DATE,
  TIME_PERIODS,
} from 'components/reports/Metrics/constants/ExceptionMetrics'

import { VEHICLE_TYPES } from '../constants/vehicleTypes'
import { ExceptionMetricsFilterValues } from './ExceptionMetricsFilterCriteria'
import { ServiceCodeMultipleAutocomplete } from './ServiceCodeMultipleAutocomplete'

export const ExceptionMetricsFiltersForm = () => {
  const { control } = useFormContext<ExceptionMetricsFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const isCustom = period === 'custom'

  const earliestDate = METRICS_EARLIEST_DATE

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      useFlexGap
      flexWrap='wrap'
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
      <ControlledSelector
        control={control}
        name='period'
        label='Time period'
        options={TIME_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 180 }}
      />

      {isCustom && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={earliestDate}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? earliestDate}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <ServiceCodeMultipleAutocomplete />

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 180 }}
      />
    </Stack>
  )
}
